import React, { useMemo } from 'react';
import { useFeatureFlagsContext, useRootContext } from '@jarvis/react-portal-addons';
import GenericThemeProvider from '../../../shared/GenericThemeProvider';
import {
  Container, Grid, StatusContainer, UsageContainer,
} from './styles';
import SolutionCards from '../SolutionCards';
import HPUsageDataWidget from '../../HPUsageDataWidget';
import useAccountApiCall from '../../../hooks/useAccountApiCall';
import useDeviceCacheApiCall from '../../../hooks/useDeviceCacheApiCall';
import StatusWidget from '../../StatusWidget';
import Banner from '../Banner';

const AdminConsolidatedDashboard = () => {
  const { dashboardUsageDataUnitFromOrg, consolidatedPortalUsageDataTelemetryCheck } = useFeatureFlagsContext();
  const { shell, stack } = useRootContext();

  const { authProvider, localization: { country: urlCountry } } = shell;

  const currentDate = useMemo(() => new Date(Date.now()), []);

  const accountCall = useAccountApiCall({
    init: dashboardUsageDataUnitFromOrg,
  });

  const country = dashboardUsageDataUnitFromOrg ? (accountCall.data?.regionId || urlCountry) : urlCountry;

  const deviceCache = useDeviceCacheApiCall({
    authProvider,
    stack,
    init: true,
  });

  return (
    <GenericThemeProvider>
      <Container data-testid="admin-dashboard">
        <Banner data-testid="banner-container" deviceCache={deviceCache} />

        <Grid>
          <SolutionCards
            deviceCache={deviceCache}
          />

          <StatusContainer data-testid="status-container">
            <StatusWidget
              stack={stack} deviceCache={deviceCache}
              consolidatedPortal
            />
          </StatusContainer>

          <UsageContainer data-testid="hp-usage-data-container">
            <HPUsageDataWidget
              data-testid="addons-hp-data-usage-widget"
              deviceCache={deviceCache}
              currentDate={currentDate}
              country={country}
              consolidatedPortal
              useTelemetryDiscoveryCheck={consolidatedPortalUsageDataTelemetryCheck}
            />
          </UsageContainer>
        </Grid>
      </Container>
    </GenericThemeProvider>
  );
};

export default AdminConsolidatedDashboard;
